import React, { useEffect, useState } from "react";
import Fuse from "fuse.js";
import CardHeader from "../atoms/CardHeader";
import CardTables from "../atoms/CardTables";
import ClientsTable from "../organisms/clientes/ClientsTable";
import CreateClient from "../organisms/clientes/CreateClient";
import GlobalSearch from "../organisms/buscadores/GlobalSearch";
import { GET_ACCOUNTANTS, GET_ADMINS, GET_CLIENT_CONTACT } from "../../api/apiAdmin";
import Breadcrumb from "../molecules/Breadcrumb";

const ClientesTemplate = () => {
    const [clients, setClients] = useState();
    const [filteredClients, setFilteredClients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ user: "", email: "" });
    const [acconuntants, setAccountants] = useState([]);
    const [admins, setAdmins] = useState([]);

    const getClients = async () => {
		try {
            setLoading(true);
			const clientsData = await GET_CLIENT_CONTACT();
            const sortedData = clientsData.sort((a, b) => a.id - b.id)
            setClients(sortedData);
            setFilteredClients(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
            setLoading(false);
        }
	};

    const getAccountants = async () => {
        try {
            const accountantsData = await GET_ACCOUNTANTS();
            setAccountants(accountantsData);
        } catch (error) {
            console.error(error);
        }
    };

    const getAdmins = async () => {
        try {
            const adminsData = await GET_ADMINS();
            setAdmins(adminsData);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getAccountants();
        getAdmins();
    }, []);

	useEffect(() => {
        getClients();
    }, []);

    useEffect(() => {
        if (!clients) return;

        const options = {
            keys: ["name", "user.email"],
            threshold: 0.3,
        };

        const fuse = new Fuse(clients, options);

        const searchTerms = `${filters.user} ${filters.email}`.trim();

        if (searchTerms) {
            const results = fuse.search(searchTerms).map(result => result.item);
            setFilteredClients(results);
        } else {
            setFilteredClients(clients);
        }
    }, [filters, clients]);

    return(
        <div className="flex flex-col space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/dashboard" },
                        { label: "Clientes", to: null },
                    ]}
                />
                <CreateClient refetch={getClients}/>
            </CardHeader>
            <CardTables>
                <GlobalSearch filters={filters} setFilters={setFilters} />
                <ClientsTable
                    data={filteredClients}
                    refetch={getClients}
                    loading={loading}
                    accountants={acconuntants || []}
                    admins={admins || []}
                />
            </CardTables>
        </div>
    )
};

export default ClientesTemplate;